<template>
  <div class="DetailsBody">
    <div class="DetailsHead">
      <div class="IntroduceLeft">
        <div class="" style="display: flex;" >
          <img
                  :src="user.pic"
                  prop="image"
                  alt=""
                  style="width: 270px; height: 210px"
                />
        </div>
        <div class="IntroduceRight">
          <div style="color: #002147; font-size: 30px; font-weight: bold">
            {{user.title}}
          </div>
          <div
            style="
              color: #666666;
              font-size: 18px;
              margin-top: 20px;
              margin-bottom: 25px;
            "
          >
            课程领域：生产管理
          </div>
          <div class="SupportService">
            <div
              style="
                width: 68px;
                color: #212529;
                font-size: 16px;
                padding: 12px 0;
              "
            >
              支持服务
            </div>
            <div style="display: flex">
              <div class="Services" v-for="item in server" :key="item.id">
                <img
                  style="width: 19px; height: 19px; vertical-align: text-bottom"
                  :src="item.img"
                  alt=""
                /><span style="font-size: 16px"> {{ item.text }}</span>
              </div>
            </div>
          </div>
          <div style="display: flex; margin-top: 24px">
            <div
              style="
                width: 68px;
                color: #212529;
                font-size: 16px;
                padding: 12px 0;
              "
            >
              咨询电话
            </div>
            <div class="Phone">{{15432965478}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="DetailsMiddle">
      <div class="Specifics">
        <div style="margin-bottom: 17px">
          <img
            style="width: 19px; height: 19px"
            src="https://www.zljst.com/subpage/course_details/img/detail.png"
            alt=""
          /><span style="font-size: 20px; font-weight: bold; color: #002147">
            课程详情</span
          >
        </div>
        <div style="margin-bottom: 27px">
          <img
            style="width: 13px; height: 14px"
            src="https://www.zljst.com/subpage/course_details/img/school.png"
            alt=""
          /><span style="font-size: 16px; font-weight: bold; color: #002147">
            课程背景</span
          >
        </div>
        <div class="Paragraph">
          {{ user.courseContent }}
          <!-- 伴随人类社会工业化的进程，工业工程走过了百年历史。工业工程（IE）是一门旨在提高生产效率和经济效益的工程技术，其任务是研究生产经营及管理系统的设计、改善和实施；其方法是综合运用自然科学、社会科学和工程技术知识，进行科学的规划、设计、实施、评价和创新，把各种生产要素（人员、物料、设备、能源、场地和信息等）组成更富有生产力和有效运行的整体系统，从而不断降低成本、确保质量、提高生产率。是一门把技术与管理有机地结合起来的学科。 -->
        </div>
        <!-- <div style="margin-bottom: 27px">
          <img
            style="width: 13px; height: 14px"
            src="https://www.zljst.com/subpage/course_details/img/lean_user.png"
            alt=""
          /><span style="font-size: 16px; font-weight: bold; color: #002147">
            学习对象</span
          >
        </div>
        <div class="Paragraph">基层员工,中层管理者</div>
        <div style="margin-bottom: 27px">
          <img
            style="width: 13px; height: 14px"
            src="https://www.zljst.com/subpage/course_details/img/school.png"
            alt=""
          /><span style="font-size: 16px; font-weight: bold; color: #002147">
            学习收益</span
          >
        </div> -->
        <!-- <div class="Paragraph"></div> -->
      </div>

      <div class="LecturerCard">
        <div style="margin-bottom: 17px">
          <img
            style="width: 19px; height: 19px"
            src="https://www.zljst.com/subpage/course_details/img/detail.png"
            alt=""
          /><span style="font-size: 20px; font-weight: bold; color: #002147">
            讲师资料</span
          >
        </div>
        <div style="display: flex">
          <div style="padding: 0 15px">
            <img
              style="width: 130px; height: 180px"
             :src="techer.pic"
              alt=""
            />
          </div>
          <div>
            <div style="font-size: 22px; font-weight: bold">{{ techer.name }}</div>
            <div style="display: flex; margin-bottom: 26px; margin-top: 12px">
              <span class="star" style="font-size: 22px; color: #d00e11"
                >&#10032;</span
              >
              <span class="star" style="font-size: 22px; color: #d00e11"
                >&#10032;</span
              >
              <span class="star" style="font-size: 22px; color: #d00e11"
                >&#10032;</span
              >
              <span class="star" style="font-size: 22px; color: #d00e11"
                >&#10032;</span
              >
              <span class="star" style="font-size: 22px; color: #d00e11"
                >&#10032;</span
              >
            </div>
            <div class="Experience">
              <div v-html="techer.aptitude"></div>
            </div>
          </div>
        </div>
        <div style="padding: 0 110px; margin-top: 8px">
          <button class="to_teacher" @click="getName(techer.id)">去老师主页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import user from '@/api/user';

export default {
  name: "courseDetail",
  data() {
    return {
      user:[],
      techer:[],
      server: [
        {
          id: 1,
          img: "https://www.zljst.com/subpage/course_details/img/reearch.png",
          text: "训前调研",
        },
        {
          id: 2,
          img:
            "https://www.zljst.com/subpage/course_details/img/custom_made.png",
          text: "定制内容",
        },
        {
          id: 3,
          img: "https://www.zljst.com/subpage/course_details/img/good.png",
          text: "满意度付费",
        },
      ],
    };
  },
  created() {
    this.getCourseDetail();
    this.getTeacherDetail();
  },
  methods: {
    getCourseDetail() {
      let _this = this;
      let id = _this.$route.params.id;
      console.log("getCourseDetailid555:", id);
      _this.$api.courseZ
        .getCourseDetail(id)
        .then((res) => {
          console.log("getCourseDetailres:", res);
          if (res.code == _this.$commons.RespCode.success) {
            _this.user = res.data;
          }
        })
        .catch(() => {});
    },
    getName(res) {
      //return this.$router.resolve({ name: 'specialist1',params:{ id : res} }).href;
      //  return this.$router.resolve({ name: 'specialist1' }).href;
      this.$router.push({ name: "specialist1", params: { id: res } });
    },
    getTeacherDetail(){
     let _this = this;
      // let id = _this.$route.params.id;
      let lecturerId = _this.$route.params.lecturerId;
       console.log("getTeacherDetailid1111111:", lecturerId);
      _this.$api.lecturerZ
        .getTeacherDetail(lecturerId)
        .then((res) => {
          console.log("教师信息：：：：：",res.data);
          if (res.code == _this.$commons.RespCode.success) {
            _this.techer = res.data;
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.DetailsBody,
.DetailsHead {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.DetailsBody {
  background-image: url("https://www.zljst.com/subpage/course_details/img/background_header.png");
  background-repeat: no-repeat;
  background-color: rgb(246, 246, 246);
  background-size: cover;
}
.IntroduceLeft {
  min-width: 1200px;
  display: flex;
  background-color: #ffffff;
  margin-top: 20px;
  padding: 20px;
}
.Introduce img {
  width: 483px;
  height: 298px;
}
.IntroduceRight {
  padding-left: 30px;
}
.SupportService {
  width: 440px;
  display: flex;
  justify-content: space-between;
}
.Services {
  width: 120px;
  height: 48px;
  color: #d52330;
  background-color: #f7f7f7;
  text-align: center;
  padding: 12px 0;
}

.Day {
  width: 120px;
  height: 48px;
  background-color: #fff3f3;
  text-align: center;
  padding: 12px 0;
  border: 1px solid #d52330;
  margin-left: 12px;
}
.Ask,
.Appointment {
  width: 160px;
  height: 50px;
  margin-right: 32px;
  font-size: 20px;
  text-align: center;
  line-height: 50px;
  font-weight: 400;
  color: #ffffff;
}
.Ask {
  background-color: #d52330;
}
.Appointment {
  background-color: #002147;
}
.DetailsMiddle {
  margin-top: 30px;
  width: 1200px;
  display: flex;

  justify-content: space-between;
}
.Specifics {
  width: 800px;
  padding: 30px;
  background-color: #ffffff;
}
.Paragraph {
  font-size: 16px;
  line-height: 28px;
  border-bottom: 1px dashed #e6e6e6;
  padding-bottom: 45px;
  color: #000000;
  margin-bottom: 30px;
}
.LecturerCard {
  width: 370px;
  padding: 30px 15px 15px 15px;
  background-color: #ffffff;
}

.star {
  font-family: "themify", serif;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
}
.Experience {
  font-size: 14px;
  font-weight: 400;
  color: #555555;
  line-height: 25px;
  min-height: 100px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.to_teacher {
  cursor: pointer;
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
  width: 120px;
  font-size: 14px;
  background-color: #d52330;
  color: #ffffff;
  text-align: center;
  margin-bottom: 10px;
}
.teacher_describe {
  background-color: #f1f1f1;
  font-size: 17px;
  font-family: Microsoft YaHei, serif;
  font-weight: 400;
  color: #333333;
  height: 54px;
  line-height: 54px;
  padding-left: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Phone {
  width: 120px;
  height: 48px;
  font-size: 16px;
  text-align: center;
  padding: 12px 0;
  margin-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/view/server/courseDetail.vue